
$(function() {
    var contactGallerySettings = {
        autoplay: false,
        autoplayControls: false,
        thumbnail: false,
        download: false,
        share: false,
        rotate: false,
        fullScreen: false,
        videoMaxWidth: "1140px",
        iframeMaxWidth: "100%",
        enableDrag: true,
        enableTouch: true,
        zoom: false
    };

    // console.log(lightGallery);
    $('.js-lightbox-contact').lightGallery(
        $.extend({}, contactGallerySettings, {
            thumbnail: true,
            selector: '.js-lightbox',
            exThumbImage: 'data-thumb',
            galleryId: 1
        })
    );

    $('.js-trigger-lg').on('click', function(event) {
        var index = 3;
        
        event.preventDefault();

        if (checkResolution('cxs')) {
            index = 2;
        }

        $(this).parents('.js-lightbox-contact').find('.c-about-gallery__item').eq(index).find('.js-lightbox').click();
    });

    $('.js-form-contact select').not('.is-loaded').multiselect({
        templates: {
            button: `
                <button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown">
                    <span class="multiselect-selected-text"></span>
                    <i aria-hidden="true" class="ico ico-caret-down"></i>
                </button>
            `
        },
        buttonClass: 'c-btn',
        enableHTML: true
    });
});
